import {v4 as uuidv4} from 'uuid';
import {Channel} from '@/types/channel';
import {EventType} from '@/types/event-type';

export class Camera {
  constructor(
    public event: string,
    public title: string = '',
    public channel?: Channel,
    public type: CameraType | string = CameraType.FLAT,
    public image: string = '',
    public id: string = uuidv4(),
    public streamIn = {},
    public streamOut = {}
  ) {
  }
}

export type SavedCameraType = Omit<Camera, 'event'> & {event: EventType}

export enum CameraType {
  FLAT = 'FLAT',
  VR360MONO = 'VR360MONO',
  VR360STEREO = 'VR360STEREO',
  VR180MONO = 'VR180MONO',
  VR180STEREO = 'VR180STEREO',
  VRTELEPRESENT = 'VRTELEPRESENT',
  FLATTELEPRESENT = 'FLATTELEPRESENT'
}

export const CameraResolution = {
  '360': '360',
  '720': '720',
  '960': '960',
  '1080': '1080',
  '1440': '1440',
  '4k': '4k',
  'SD': 'SD',
  'HD': 'HD',
  'FHD': 'FHD',
  '2,7K': '2,7K',
  '4K': '4K'
};
